export const TYPE_VIEW_DESIGN = 'Design';
export const TYPE_VIEW_VIDEO = 'Video';
export const TYPE_VIEW_IMAGE = 'Image';
